/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Definition_LabelInputs */

const en_tags_manager_definition_label = /** @type {(inputs: Tags_Manager_Definition_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definition`)
};

const fr_tags_manager_definition_label = /** @type {(inputs: Tags_Manager_Definition_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definition`)
};

const de_tags_manager_definition_label = /** @type {(inputs: Tags_Manager_Definition_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definition`)
};

const it_tags_manager_definition_label = /** @type {(inputs: Tags_Manager_Definition_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definizione`)
};

const ru_tags_manager_definition_label = /** @type {(inputs: Tags_Manager_Definition_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Определение`)
};

const es_tags_manager_definition_label = /** @type {(inputs: Tags_Manager_Definition_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definición`)
};

const zh_cn2_tags_manager_definition_label = /** @type {(inputs: Tags_Manager_Definition_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定义`)
};

const ja_tags_manager_definition_label = /** @type {(inputs: Tags_Manager_Definition_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意味`)
};

const hi_tags_manager_definition_label = /** @type {(inputs: Tags_Manager_Definition_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिभाषा`)
};

const pt_pt2_tags_manager_definition_label = /** @type {(inputs: Tags_Manager_Definition_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definição`)
};

/**
* | output |
* | --- |
* | "Definition" |
*
* @param {Tags_Manager_Definition_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_definition_label = /** @type {((inputs?: Tags_Manager_Definition_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Definition_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_definition_label(inputs)
	if (locale === "de") return de_tags_manager_definition_label(inputs)
	if (locale === "it") return it_tags_manager_definition_label(inputs)
	if (locale === "ru") return ru_tags_manager_definition_label(inputs)
	if (locale === "es") return es_tags_manager_definition_label(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_definition_label(inputs)
	if (locale === "ja") return ja_tags_manager_definition_label(inputs)
	if (locale === "hi") return hi_tags_manager_definition_label(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_definition_label(inputs)
	return en_tags_manager_definition_label(inputs)
});